/* eslint-disable camelcase */
import {
  SecuritySettingsState,
  SecuritySettingsActionTypes,
  SECURITY_SETTINGS_REQUEST,
  SECURITY_SETTINGS_SUCCESS,
  SECURITY_SETTINGS_FAILURE,
} from "./types";
import { DEFAULT_SECURITY_SETTINGS } from "../../../models/securitySettingsData";

/**
 * Initial state for the security settings reducer.
 */
const initialState: SecuritySettingsState = {
  securitySettings: {
    ...DEFAULT_SECURITY_SETTINGS,
  },
  isLoading: false,
  error: false,
  isLoaded: false,
};

/**
 * Reducer handling security settings state changes.
 *
 * Manages security settings data, loading state, and error state
 * based on dispatched actions.
 *
 * @param state - Current security settings state.
 * @param action - Action dispatched to update the state.
 * @returns Updated state after applying the action.
 */
export const securitySettingsReducer = (
  state = initialState,
  action: SecuritySettingsActionTypes
): SecuritySettingsState => {
  switch (action.type) {
    case SECURITY_SETTINGS_REQUEST:
      return { ...state, isLoading: true, error: false, isLoaded: false };
    case SECURITY_SETTINGS_SUCCESS:
      return {
        ...state,
        securitySettings: action.data,
        isLoading: false,
        error: false,
        isLoaded: true,
      };
    case SECURITY_SETTINGS_FAILURE:
      return { ...state, isLoading: false, error: true, isLoaded: false };
    default:
      return state;
  }
};

export default securitySettingsReducer;
